import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../store';
import { dismissNotification } from './notificationActions';
import { Notification } from './notificationTypes';
import './toast.css';

const Toast: React.FC<{ item: Notification }> = ({ item }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!item.duration) return;
    const t = setTimeout(() => dispatch(dismissNotification(item.id)), item.duration);
    return () => clearTimeout(t);
  }, [item.id, item.duration, dispatch]);

  return (
    <div className={`toast toast--${item.type}`}>
      <span className="toast__msg">{item.message}</span>
      <button
        className="toast__close"
        onClick={() => dispatch(dismissNotification(item.id))}
        aria-label="Dismiss"
      >
        ×
      </button>
    </div>
  );
};

const ToastContainer: React.FC = () => {
  const items = useSelector((s: RootState) => s.Notifications.items);
  if (!items.length) return null;
  return (
    <div className="toast-container">
      {items.map(n => <Toast key={n.id} item={n} />)}
    </div>
  );
};

export default ToastContainer;
